import { container, TitleContainer, Icon, Title, ActionButton, SubTitle, TitleSubtitleContainer } from './styles';

interface IProps {
  icon: JSX.Element;
  title: string;
  actionButton?: {
    text: string;
    onClick: () => void;
  };
  subTitle?: string;
  dataTestId?: string;
}

function CheckoutSectionHeader({ icon, title, actionButton, subTitle, dataTestId }: IProps): JSX.Element {
  return (
    <div css={container}>
      <TitleContainer>
        <Icon data-testid={dataTestId && `${dataTestId}-icon`}>{icon}</Icon>
        <TitleSubtitleContainer>
          <Title as="h2" data-testid={dataTestId && `${dataTestId}`}>
            {title}
          </Title>
          {subTitle && <SubTitle>{subTitle}</SubTitle>}
        </TitleSubtitleContainer>
      </TitleContainer>

      {actionButton?.text && <ActionButton onClick={actionButton?.onClick}>{actionButton.text}</ActionButton>}
    </div>
  );
}

export default CheckoutSectionHeader;
